import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../../component/MotionWrapper';
import axios from 'axios';
import Letter from '../../component/Spring/Letter';
import Dday_Spring from '../../component/Spring/Dday_Spring';
import Message_Spring from '../../component/Spring/Message_Spring';
import Location_Spring from '../../component/Spring/Location_Spring';
import Footer from '../../component/Footer';
import Loading from '../../component/Loading';
import Location_Desc from '../../component/Location/Location_Desc';
import Music from '../../component/Music';
import Sharing from '../../component/Sharing';
import GalleryList from '../../component/Gallery/GalleryList';
import Main_Summer from '../../component/Summer/Main_Summer';
import Save_Date from '../../component/Save_Date';
import Interview_Spring from '../../component/Spring/Interview_Spring';
import Info_Spring2 from '../../component/Spring/Info_Spring2';
import AccountList2 from '../../component/Account/AccountList2';
import ParentInfo from '../../component/Info/ParentInfo';



const RyuHanHee = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "나정철 ♥︎ 류한희 결혼합니다.";
    const openDesc = "25년 8월 31일 오전 11시";
    const openThumb = "https://d39wt6wnedokd1.cloudfront.net/276/thumb.jpg";

    const lng = 127.0413954371061;
    const lat = 37.559572611956774 ;

    const placeTelNum = "02-2299-9999";

    const forBus = "지선 | 2012, 2013, 2014, 2220, 2222, 2411, 2016\n간선 | 263, 302, 371";
    const forSubway = "2호선 | 한양대역 1번출구 (도보5분거리)\n5호선 | 왕십리역 6번출구 (도보5분거리)";
    const forCar = "H스퀘어 동문회관 주차장, 한양대학병원 주차장 \n(1시간 30분 무료 주차)";

    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });


    const conceptStyle = {
        // summer 올리브
        concept: "SUMMER",
        titleColor: "#405200",
        pointColor: "#405200",
        btnBgColor: "#405200",
        fontColor: "#fff",
        btnFontColor: "#fff",
        chatBgColor: "#F5F8FF",
        fontFamilyKo: "JejuMyeongjo",
        fontFamilyEn: "Milchella"
    }

    const title = "우리 결혼합니다.";

    const msg1 = "사랑이 수많은 계절을 지나\n하나의 마음으로 수렴되었습니다.";
    const msg2 = "오랜 여정을 함께한 두 사람은\n이제 서로의 행복이 되어\n한 걸음 더 내딛고자 합니다."
    const msg3 = "소중한 분들의 따뜻한 응원속에서\n저희의 새로운 시작을 함께하고 싶습니다."
    const msg4 = "기쁜 날, 귀한 걸음으로 축복해 주신다면\n그 마음 오래도록 간직하며 살아가겠습니다.\n\n\n";


    // const parents = [
    //     {groom : "나종욱 · 김은희의 아들"},
    //     {bride : "류중호 · 전혜진의 딸"}
    // ]


    const parentInfo = {
        groom: {
            dad: { name: "나종욱", isDeceased: false },
            mom: { name: "김은희", isDeceased: false },
            role: "아들",
        },
        bride: {
            dad: { name: "류중호", isDeceased: false },
            mom: { name: "전혜진", isDeceased: false },
            role: "딸",
        }
    };

    const groomAccountList = [
        {
            role: "신랑",
            name: "나정철",
            bank: "신한은행",
            accountNumber : "110-415-749727",
            isKakao : false
        }
        ,{
            role: "신랑 부",
            name: "나종욱",
            bank: "국민은행",
            accountNumber : "417802-04-063858",
            isKakao : false
        }
        ,{
            role: "신랑 모",
            name: "김은희",
            bank: "농협은행",
            accountNumber : "356-1609-7574-13",
            isKakao : false
        }
    ]

    const brideAccountList = [
        {
            role: "신부",
            name: "류한희",
            bank: "신한은행",
            accountNumber : "110-261-885750",
            isKakao : false
        }
        ,{
            role: "신부 부",
            name: "류중호",
            bank: "신한은행",
            accountNumber : "110-008-428047",
            isKakao : false
        }
        ,{
            role: "신부 모",
            name: "전혜진",
            bank: "신한은행",
            accountNumber : "110-285-707968",
            isKakao : false
        }
    ]

    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 가지지 않으셨으면 좋겠습니다."

    const interviewContent = [
        {
            question : "우리의 설레였던 첫 만남 기억해?",
            groomAnswer: "완전 생생해!",
            brideAnswer: "잊을 수 없는 날"
        },
        {
            question : "결혼을 앞둔 소감이 어때?",
            groomAnswer: "만감이 교차!",
            brideAnswer: "나도 그래!"
        },
        {
            question : "서로에게 하고 싶은 말은?",
            groomAnswer: "평생 사랑해!",
            brideAnswer: "이제 내꺼다!"
        },
        {
            question : "유부남/녀 기념 각오 한마디!",
            groomAnswer: "젤 잘해줄게!",
            brideAnswer: "내가 더!"
        },
        {
            question : "마지막으로 전하고 싶은 이야기는?",
            groomAnswer: "행복히 살자!",
            brideAnswer: "잘 살아보장"
        },
    ]

    const groomCallInfoList = [
        {
            role: "신랑",
            name: "권유안",
            call: "010-2340-2172"
        }
        ,{
            role: "신랑 부",
            name: "권길택",
            call: "010-7979-1172"
        }
        ,{
            role: "신랑 모",
            name: "박미숙",
            call: "010-7302-1173"
        }
    ]

    const brideCallInfoList = [
        {
            role: "신부",
            name: "정소현",
            call: "010-9043-2745"
        }
        ,{
            role: "신부 부",
            name: "정태진",
            call: "010-3768-2286"
        }
        ,{
            role: "신부 모",
            name: "김현옥",
            call: "010-2745-2286"
        }
    ]

    const informationList =[
        {
            title : "ATM 기기 안내",
            content : "주변엔 ATM기기가 없습니다. \n이점 양해 부탁드립니다."
        }
    ]

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstNameEn = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };

    // ex. Kim Gayeong
    const getRemoveSpaceName = (fullName) => {
        const nameParts = fullName.split(' '); // 문자열을 띄어쓰기로 분리
        const firstName = nameParts[0]; // 첫 번째 단어 유지
        const restName = nameParts.slice(1).join(''); // 나머지 단어를 소문자로 변경하고 결합
        return firstName + ' ' + restName.charAt(0).toUpperCase() + restName.slice(1).toLowerCase();
    };

        // 성을 제외하고 이름만 추출 ex.Gayeong
        const getFirstEnName = (fullName) => {
            const nameParts = fullName.split(' '); 
            const firstName = nameParts.slice(1).join(''); 
            return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
        };
        
        // 브라운 #5b0100
        // #761B40
        // #423866
        // #d98db9
        // #FF8A83
    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#405200"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept}/>
                    <Main_Summer weddingData={weddingData} groomNameEn={getRemoveSpaceName(weddingData.brideNameEn)} brideNameEn={getRemoveSpaceName(weddingData.groomNameEn)} color={"#405200"} letteringFontColor={"#69820e"} dateColor={"#405200"} bottom={"28%"} bottom2={"18.5%"} dateBottom={"2%"} top={"5%"}/>
                    <Save_Date color={conceptStyle.pointColor} isBorder={true} marginTop={"100px"} marginBottom={"10px"} fontSize={"13px"} />
                    <Info_Spring2 weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={getFirstEnName(weddingData.brideNameEn)} groomNameEn={getFirstEnName(weddingData.groomNameEn)}/>
                    <Letter title={title} msg1={msg1} msg2={msg2} msg3={msg3} msg4={msg4} conceptStyle={conceptStyle} />
                    {/* <CallInfo marginTop={"30px"} conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/> */}
                    <MotionWrapper initialY={70}>
                        <ParentInfo conceptStyle={conceptStyle} parentInfo={parentInfo} weddingData={weddingData}/>
                    </MotionWrapper>
                    <Dday_Spring isAttendFromClose={true} brideName={getFirstKoName(weddingData.brideName)} groomName={getFirstKoName(weddingData.groomName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={50}>
                        <GalleryList fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={6} photoWidth={"150px"} photoHeight={"235px"} gap={"3px"}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <AccountList2 conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <Message_Spring weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} 
                            conceptStyle={conceptStyle} 
                            btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.titleColor}
                            />
                    </MotionWrapper>
                    {/* <Information conceptStyle={conceptStyle} informationList={informationList} /> */}
                    <MotionWrapper initialY={50}>
                        <Interview_Spring interviewContent={interviewContent} weddingData={weddingData} conceptStyle={conceptStyle} />
                        <Location_Spring weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                    </MotionWrapper>
                    <Location_Desc isPoint={true} forCar={forCar} forBus={forBus} forSubway={forSubway} conceptStyle={conceptStyle}/>
                    <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                    <Footer />
                </>
            )}
        </div>
    );
    
};

export default RyuHanHee;